import { useTranslation } from 'react-i18next';
import { Message, RadioButton, spacing } from 'component-library';
import { type ForSomeoneElseProps } from '../../types';
import { ChooseOtherUser } from '../ChooseOtherUser';
import SelectedUser from './SelectedUser';
import SelectHierarchy from './SelectHierarchy';
import { ORDER_FOR_SOMEONE_ELSE_VALUE } from './constants';
import { NoValidCostCenter } from './NoValidCostCenter';

const ForSomeoneElse = ({
  active,
  handleSelectUsersCategory,
  users,
  usersLoading,
  selectedUserId,
  handleSelectUser,
  getUserDetailsFromId,
  hierarchies,
  handleSelectHierarchy,
  selectedHierarchy,
  getSelectedHierarchyDetailsFromDwKey,
  disabled,
  hasAvailableCostCenters,
  allowedToPurchaseSubscription,
  subscriptionType,
}: ForSomeoneElseProps) => {
  const { t } = useTranslation();

  return (
    <>
      <RadioButton
        checked={active}
        disabled={disabled}
        label={t('subscription.checkout.step1.radio2.label')}
        value={ORDER_FOR_SOMEONE_ELSE_VALUE}
        description={t('subscription.checkout.step1.radio2.description')}
        onChange={handleSelectUsersCategory}
      />
      {active && users && !usersLoading && (
        <ChooseOtherUser
          partnerUsers={users}
          loading={usersLoading}
          selectedPartnerUser={selectedUserId}
          onChange={handleSelectUser}
        />
      )}
      {active && selectedUserId && hierarchies && hierarchies.length > 0 && (
        <SelectedUser
          user={getUserDetailsFromId(selectedUserId)}
          hierarchy={getSelectedHierarchyDetailsFromDwKey(selectedHierarchy)}
        />
      )}
      {active && (
        <SelectHierarchy
          hierarchies={hierarchies}
          onChange={handleSelectHierarchy}
          selected={selectedHierarchy}
          disabled={!selectedUserId}
        />
      )}
      {active &&
        selectedUserId &&
        selectedHierarchy &&
        selectedHierarchy.length > 0 &&
        !hasAvailableCostCenters && <NoValidCostCenter />}
      {active &&
        selectedUserId &&
        hierarchies &&
        hierarchies.length === 0 &&
        allowedToPurchaseSubscription && (
          <div style={{ margin: `${spacing.xxsmall} 0 ${spacing.xsmall} 0` }}>
            <Message
              description={t(
                subscriptionType === 'CO2'
                  ? 'co2_impact.checkout.errors.no.unsubscribed.hierarchies.other'
                  : 'subscription.checkout.errors.no.unsubscribed.hierarchies.someone.else.csrd',
              )}
            />
          </div>
        )}
      {active && !allowedToPurchaseSubscription && (
        <div style={{ margin: `${spacing.xxsmall} 0 ${spacing.xsmall} 0` }}>
          <Message
            severity="error"
            title={t('subscription.checkout.errors.not.allowed.to.purchase.subscription')}
            description={t(
              'subscription.checkout.errors.not.allowed.to.purchase.subscription.description',
            )}
          />
        </div>
      )}
    </>
  );
};

export default ForSomeoneElse;
